import { IWebGivingSagaContext } from '../webgiving-saga';
import { Country, Currency, WebGivingMerchant } from '../webgiving-generated';
import { getCardBrandsFromKeys } from './card-utils';

// TODO: A merchant ID is available for a production environment after approval by Google
// See https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist|Integration checklist
export const googleMerchantId = '12345678901234567890';

export type GooglePaySDKType = google.payments.api.PaymentsClient | null;

const getAllowedPaymentMethods = (merchant: WebGivingMerchant): google.payments.api.PaymentMethodSpecification => ({
    type: 'CARD',
    parameters: {
        allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
        allowedCardNetworks: getCardBrandsFromKeys(merchant.SupportedCardBrandKeys).map(
            (b) => b.shortName.toUpperCase() as google.payments.api.CardNetwork
        ),
    },
    tokenizationSpecification: {
        type: 'PAYMENT_GATEWAY',
        parameters: {
            gateway: merchant.CardGateway.toLowerCase(),
            gatewayMerchantId: merchant.GooglePayGatewayMerchantId,
        },
    },
});

export const getIsReadyToPayRequest = (MerchantInfo: WebGivingMerchant): google.payments.api.IsReadyToPayRequest => ({
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [getAllowedPaymentMethods(MerchantInfo)],
});

export const getGooglePaymentRequest = (context: IWebGivingSagaContext): google.payments.api.PaymentDataRequest => {
    const { mainViewModel, appState: { paymentState } } = context;
    const { viewData: { MerchantInfo: merchant } } = mainViewModel;
    const merchantName = merchant.ApplePayMerchantName || merchant.TradingName;
    return {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [getAllowedPaymentMethods(merchant)],
        emailRequired: true,
        merchantInfo: {
            merchantId: googleMerchantId,
            merchantName,
        },
        transactionInfo: {
            totalPriceLabel: merchantName,
            totalPrice: paymentState.calculatedAmountWithFees.toString(),
            currencyCode: Currency[merchant.Currency],
            countryCode: Country[merchant.Country],
            totalPriceStatus: 'FINAL',
        },
    };
};

export const getButtonOptions = (): google.payments.api.ButtonOptions => ({
    buttonColor: 'default',
    buttonType: 'plain',
    buttonRadius: 100,
    buttonSizeMode: 'fill',
    onClick: () => {}, // Replaced when creating the button
});

export const googleSdkExists = (): boolean =>
    (window as any).google && (window as any).google.payments && (window as any).google.payments.api;

// The user has cancelled the google pay sheet
export const isCancelError = (error: unknown): boolean =>
	typeof error === 'object' && error !== null && 'statusCode' in error && (error as google.payments.api.PaymentsError).statusCode === 'CANCELED';

